
/**
 * @fileOverview mmmThemeControls Module controls the PSN and other theme elements
 *
 * @author jjurisch
 * @version 1.0
 * @modified 12/27/2013
 */
(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/mmmThemeControls',['require','lib/Util','jquery'],function (require) {
        var Util = require('lib/Util');
        var $ = require('jquery');

        /**
         * Sample ajax call, this file should be removed when true ajax calls are constructed.
         *
         * @class mmmTheme
         * @since 1.0
         */
        var mmmThemeControls = function () {
            $debug('mmmThemeControls loaded - use ?debug=mmmThemeControls for messages');
            $debug('**** mmmThemeControls Set Up Started **** ', 'mmmThemeControls');
            this.init();
        };

        /**
         * Initializes the Module
         * Runs a single setupSearchHandlers call, followed by createChildren and layout
         *
         * @method init
         * @returns {mmmThemeControls}
         * @private
         */
        mmmThemeControls.prototype.init = function () {
            return this.setOptions()
                .setupSearchHandlers()
                .setupPSNHandlers();
        };

        /**
         *
         * This takes in data options from the SETTINGS object and overwrites any default values. If there is no value in the data
         * options tag then defaults are shown below.
         *
         * @method setOptions
         * @returns {mmmThemeControls}
         * @private
         */
        mmmThemeControls.prototype.setOptions = function () {
            var options = SETTINGS;

            var defaults = {
                BASE_URL: '/3MTheme/themes/html/assets/3M-loadWCM.jsp?PATH=',
                GSN1_PATH : '',
                GSN2_PATH : '',
                GSN3_PATH : '',
                GSN4_PATH : '',
                GSN5_PATH : '',
                GSN6_PATH : '',
                GSN7_PATH : '',
                GSN8_PATH : '',
                GSN9_PATH : '',
                ALL_PROD_PATH : '',
                PLACEUN: undefined,     //place unique name
                LOCALE : undefined     //page locale
            };
            this.settings = $.extend({}, defaults, options);
            $debug('Setting Main Options ', 'mmmThemeControls');
            $debug('     Settings Object: ' + $printObj(options),'mmmThemeControls');
            $debug('     Module Default Settings: ' + $printObj(defaults),'mmmThemeControls');
            $debug('     New Combined Settings: ' + $printObj(this.settings),'mmmThemeControls');

            return this;
        };

        /**
         * Sets up the search box/button handlers
         * Should only be run on initialization of the view
         *
         * @method setupSearchHandlers
         * @returns {mmmThemeControls}
         * @private
         */
        mmmThemeControls.prototype.setupSearchHandlers = function () {
            var self = this;
            $debug('Setting up Search Box Handlers','mmmThemeControls');

            //remove placeholder text
            $('.MMM--headerSearchInput, .MMM--mobileSearchInput').on('focus', function(e) {
                $debug('*** .MMM--headerSearchInput focus ***','mmmThemeControls');
                var $this = $(this);
                $this.attr('data-placehold', $this.attr('placeholder'));
                $this.attr('placeholder','');
            });

            //replace placeholder text
            $('.MMM--headerSearchInput, .MMM--mobileSearchInput').on('blur', function(e) {
                $debug('*** .MMM--headerSearchInput blur ***','mmmThemeControls');
                var $this = $(this);
                $this.attr('placeholder', $this.data('placehold'));
            });

            //if search box is empty - do nothing (doesn't seem to exist on page)
            $('#desktopSearchButton').on('click', function(e) {
                $debug('*** desktopSearchButton Clicked ***','mmmThemeControls');
                $('#desktopSearch').attr('placeholder', '');
                if(!$('#desktopSearch').val().length) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    else {
                        //needed for IE Support
                        e.returnValue = false;
                    }
                }
            });

            //if search box is empty - do nothing
            $('#tabletSearchButton').on('click', function(e) {
                $debug('*** tabletSearch Clicked ***','mmmThemeControls');
                $('#tabletSearch').attr('placeholder', '');
                if(!$('#tabletSearch').val().length) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    else {
                        //needed for IE Support
                        e.returnValue = false;
                    }
                }
            });

            //if search box is empty - do nothing
            $('#mobileSearchButton').on('click', function(e) {
                $debug('*** mobileSearch Clicked ***','mmmThemeControls');
                $('#mobileSearch').attr('placeholder', '');
                if(!$('#mobileSearch').val().length) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    else {
                        //needed for IE Support
                        e.returnValue = false;
                    }
                }
            });

            //if search box is empty - do nothing
            $('#MSDSSearchButton').on('click', function(e) {
                $debug('*** MSDSSearch Clicked ***','mmmThemeControls');
                $('#MSDSSearch').attr('placeholder', '');
                if(!$('#MSDSSearch').val().length) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    else {
                        //needed for IE Support
                        e.returnValue = false;
                    }
                }
            });

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @method setupPSNHandlers
         * @returns {mmmThemeControls}
         * @private
         */
        mmmThemeControls.prototype.setupPSNHandlers = function () {
            $debug('Setting up PSN Handlers','mmmThemeControls');
            var self = this,
                url = '';

            //Questions to Rick:
            //A) is this ever used?
            //B) Shouldn't it already be handled with: NavigationSubMenuController?

            $('[id ^=gsn][id $=Arrow]').each(function(i,e){
                var elementID = e.id,
                    currentElement = i + 1,
                    contentsID = '#gsn' + currentElement + 'DrawerContents',
                    drawerID = '#gsn' + currentElement + 'Drawer',
                    currentPath = 'GSN' + currentElement + '_PATH',
                    url = self.settings.BASE_URL + self.settings[currentPath] + '&r=' + self.settings.CACHE_BUSTER;

                $debug('*** GSN Element Found *** ','mmmThemeControls');
                $debug('     elementID: ' + elementID,'mmmThemeControls');
                $debug('     contentsID: ' + contentsID,'mmmThemeControls');
                $debug('     drawerID: ' + drawerID,'mmmThemeControls');
                $debug('     currentPath: ' + currentPath,'mmmThemeControls');
                $debug('     url: ' + url,'mmmThemeControls');

                $(e).on('click', function(){
                    $debug(elementID + ' Clicked','mmmThemeControls');
                    if ($(contentsID).length === 0) {
                        $debug('Loading ' + url,'mmmThemeControls');
                        $(drawerID).load(url, function(){
                            $debug('Load of ' + url + ' complete.','mmmThemeControls');
                        });
                    }
                });
            });

            return this;
        };


        //When ?debug=corpJS&sanity=check is present, run the following
        if (urlHash.sanity) {
            $debug('****** mmmThemeControls Module SANITY CHECK ******');
            $debug('     Move on... nothing to see here.');
            $debug('****** END mmmThemeControls Module SANITY CHECK ******');
        }

        return mmmThemeControls;
    });

}(MMMRequire));

